export const SHOW_PAGE_REQUEST="SHOW_PAGE_REQUEST"
export const SHOW_PAGE_SUCCESS="SHOW_PAGE_SUCCESS"
export const SHOW_PAGE_FAIL="SHOW_PAGE_FAIL"